import {
  AvatarCardHeader,
  getUserSummaryLine,
} from '../../common/components/sliders/components/AvatarSliderCard';
import userPlaceholder from '../../user_profile/assets/images/placeholder_user.png';
import { useLocation } from 'react-router-dom';

export default function ReviewsList({ reviewsData }) {
  const { hash } = useLocation();

  return (
    <div className={'fishery_profile__stacked_reviews'}>
      {reviewsData.map((data, index) => (
        <div
          id={`review-${index + 1}`}
          key={`review-${index + 1}`}
          className={
            'fishery_profile__stacked_reviews__review ' +
            (`#review-${index + 1}` === hash ? ' targeted ' : '')
          }
        >
          <AvatarCardHeader
            image={{
              src: data?.profile_image || userPlaceholder,
              alt: data.first_name + ' ' + data.last_name,
            }}
            title={data.first_name + ' ' + data.last_name}
            postTitle={getUserSummaryLine(data)}
          />
          <p className={'gRegular mg-bottom-5 fs-15'}>{data.comment}</p>
        </div>
      ))}
    </div>
  );
}
